module.exports = __webpack_public_path__ + "img/w3_bil_dark.08322667.png";